import { computed } from '@vue/composition-api';
import { formatCurrency } from '@/util/currency';
export const useGoodsAndServicesColumns = (ctx, options) => {
    const columns = computed(() => {
        const baseColumns = [
            {
                field: 'name',
                headerName: ctx.root.$t('goods-and-services.name').toString(),
                flex: 1,
                minWidth: 150,
                sortable: true,
                valueGetter: (params) => {
                    if (params?.node?.rowPinned)
                        return '';
                    return params?.data?.name || '-';
                },
            },
            {
                field: 'unitOfMeasure',
                headerName: ctx.root
                    .$t('goods-and-services.unit-of-measure')
                    .toString(),
                width: 120,
                sortable: true,
                valueGetter: (params) => {
                    if (params?.node?.rowPinned)
                        return '';
                    return params?.data?.unitOfMeasure || '-';
                },
            },
            {
                field: 'quantity',
                headerName: ctx.root.$t('goods-and-services.quantity').toString(),
                width: 100,
                sortable: true,
                valueGetter: (params) => {
                    if (params?.node?.rowPinned)
                        return '';
                    return params?.data?.quantity
                        ? params.data.quantity.toLocaleString()
                        : '-';
                },
            },
            {
                field: 'sellPrice',
                headerName: ctx.root.$t('goods-and-services.sell-price').toString(),
                width: 120,
                sortable: true,
                valueGetter: (params) => {
                    if (params?.node?.rowPinned)
                        return '';
                    return params?.data?.sellPrice
                        ? formatCurrency(params.data.sellPrice)
                        : '-';
                },
            },
        ];
        if (options?.rows) {
            baseColumns.push({
                field: 'id',
                colId: 'total-cost',
                headerName: ctx.root.$t('offer-costs.totalCost').toString(),
                cellRenderer: 'TotalCostCell',
                cellRendererParams: (params) => {
                    const summaryCell = !!params?.node?.rowPinned;
                    const calculateTotalSum = () => {
                        if (!options.rows?.value)
                            return 0;
                        return options.rows.value.reduce((total, item) => {
                            return total + (item.quantity || 0) * (item.sellPrice || 0);
                        }, 0);
                    };
                    const cost = summaryCell
                        ? calculateTotalSum()
                        : (params?.data?.quantity || 0) * (params?.data?.sellPrice || 0);
                    return {
                        cost,
                        summaryCell,
                    };
                },
                width: 200,
                pinned: 'right',
                suppressMovable: true,
            });
        }
        return baseColumns;
    });
    return {
        columns,
    };
};
